import React, { useState, useEffect, useContext } from "react";
import { isMobile } from "react-device-detect";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props extends RouteComponentProps {}

const NotFound = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundColor: "#2c3e50",
        display: "flex",
        flexDirection: "column",
        ...(isMobile
          ? {
              overflowX: "scroll",
              width: "96%",
            }
          : {
              alignItems: "center",
              justifyContent: "center",
            }),
      }}
    >
      <h1 style={{ color: "#fff" }}>404</h1>
      <h3 style={{ color: "#fff" }}>{t("notFound.notExist")}</h3>

      <div
        style={{
          cursor: "pointer",
          padding: `10px 16px`,
          color: "#fff",
          border: "1px solid #fff",
          borderRadius: 30,
          marginTop: 30,
        }}
        onClick={() => {
          //                props.history.push('/')
          window.location.href = "/";
        }}
      >
        {t("notFound.backHome")}
      </div>
    </div>
  );
};

export default withRouter(NotFound);
